export const VIEWPORT_GEOMETRY_CINE_SUPPRESSION_MARKER = 'KAIROS_VIEWPORT_GEOMETRY_CINE_SUPPRESSION';

export const createViewportGeometryBroadcastCoordinator = ({ publish } = {}) => {
  const reasons = new Set();
  let latestIndex = null;
  let latestSnapshot = null;
  let hidden = false;

  const emit = (index, snapshot) => {
    if (typeof publish === 'function') publish(index, snapshot);
  };

  const update = (index, snapshot) => {
    latestIndex = index;
    latestSnapshot = snapshot;
    if (reasons.size > 0) return false;
    emit(index, snapshot);
    hidden = false;
    return true;
  };

  const pause = (reason = 'cine') => {
    const key = String(reason || 'cine');
    if (reasons.has(key)) return false;
    const wasActive = reasons.size > 0;
    reasons.add(key);
    if (!wasActive && latestIndex != null && !hidden) {
      emit(latestIndex, null);
      hidden = true;
    }
    return true;
  };

  const resume = (reason = 'cine') => {
    const key = String(reason || 'cine');
    if (!reasons.delete(key)) return false;
    if (reasons.size === 0 && latestIndex != null && latestSnapshot) {
      emit(latestIndex, latestSnapshot);
      hidden = false;
    }
    return true;
  };

  const invalidate = (index = latestIndex) => {
    reasons.clear();
    latestIndex = null;
    latestSnapshot = null;
    hidden = false;
    if (index != null) emit(index, null);
  };

  return {
    update,
    pause,
    resume,
    invalidate,
    snapshot: () => ({
      paused: reasons.size > 0,
      reasons: [...reasons],
      latestIndex,
      hidden,
    }),
  };
};
